import { BackToShowcaseAlert } from 'components/BackToShowcaseAlert';
import { MainNavigation } from 'components/MainNavigation';
import { MotionDiv } from 'components/MotionDiv';
import { AppContext, AppContextType } from 'context';
import { AnimatePresence } from 'framer-motion';
import React, { Fragment, useContext, useMemo } from 'react';
import { BasicPageProps } from 'types';

const SHOWCASE_DILS_URL = 'showcase.dils';

export const HomePage: React.FC<
  BasicPageProps & {
    isFullScreen: boolean;
  }
> = ({ isFullScreen }) => {
  const { useStyles } = useContext<AppContextType>(AppContext);

  const { configuration, isIpad } = useContext<AppContextType>(AppContext);
  const classes = useStyles();

  const referrerUrl = useMemo(() => document.referrer || null, []);

  const showBackToShowcaseButton = useMemo(
    () => referrerUrl?.includes(SHOWCASE_DILS_URL) || false,

    // Disable variable update in case of page change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <AnimatePresence>
      <MotionDiv
        className="homepage"
        key="homepage"
        disableMotion={Boolean(isIpad)}
      >
        <Fragment>
          <div>
            <img
              src={configuration.general.mainLogo}
              className={`img-fluid ${classes.homeLogo}`}
              alt="logo"
            />
          </div>
          <div className={classes.background}>
            {configuration.home.backgroundImage && (
              <img
                src={configuration.home.backgroundImage}
                alt="Home background"
                className={classes.backgroundObject}
              />
            )}
          </div>
          {isFullScreen &&
            showBackToShowcaseButton &&
            !window.electron &&
            referrerUrl && <BackToShowcaseAlert referrerUrl={referrerUrl} />}
        </Fragment>
      </MotionDiv>
      <MainNavigation />
    </AnimatePresence>
  );
};
